<template>
  <div class="container">
    <h3>Movie Search Engine</h3>
    <p>An app showing the use of Vue Router and ReactiveSearch, where a search bar on home screen redirects to a more advanced search page.</p>
    <DataSearch
      componentId="search"
      :dataField="['original_title', 'original_title.keyword' , 'original_title.search', 'original_title.keyword']"
      :autosuggest="true"
      placeholder="Search Movie"
      class="search-container"
      :showIcon="true"
      iconPosition="right"
      @valueSelected="valueSelected"
      :innerClass="{
        input: 'search-input',
        list: 'search-list'
      }"
    />
  </div>
</template>

<script>
export default {
  methods: {
    valueSelected: function(value) {
      if (value) {
        this.$router.push({ path: 'movies', query: { web: `"${value}"` } });
      }
    }
  }
}

</script>